import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";

export default function LogoffApp() {
    let navigate = useNavigate();

    useEffect(() => {
        localStorage.removeItem('hondixTk');
        navigate('/login')
    }, [navigate])

    return (
        <>

        </>
    )
}
